export enum PerspectivesQueries {
  List = 'perspectivesList',
  Detail = 'perspective',
  Table = 'perspectiveTable',
  Chart = 'perspectiveChart',
  ColumnValues = 'perspectiveColumnValues',
  SnapshotStatus = 'perspectiveSnapshotStatus',
  Preview = 'perspectivePreview',
  PendingCorrections = 'perspectivePendingCorrections',
}
